import { Colors } from 'libs/ui/theme';

import { SvgIcon } from '../SvgIcon';
import { SvgProps } from '../types';

interface QuestionCircleProps extends SvgProps {
  glyphColor?: Colors | string;
}

export const QuestionCircle = ({
  size = 16,
  color = Colors.black,
  glyphColor = Colors.white,
  className,
}: QuestionCircleProps) => (
  <SvgIcon className={className} size={size}>
    <svg
      color={color}
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" fill="currentColor" r="7" />
      <path
        d="M6.25 6.25C6.25 5.28 7.03 4.5 8 4.5C8.97 4.5 9.75 5.28 9.75 6.25C9.75 7.07 9.19 7.5 8.6 7.86C8.26 8.07 8 8.4 8 8.8V9.25"
        stroke={glyphColor}
        strokeLinecap="round"
        strokeWidth="1.5"
      />
      <circle cx="8" cy="11.5" fill={glyphColor} r="0.85" />
    </svg>
  </SvgIcon>
);
